  document.addEventListener("DOMContentLoaded", function() {
   
      $('.accordion').on('click',function(){
          if(!$(this).hasClass('active'))
          {
              $(this).next().slideDown();
              $('.accordion.active').next().stop().slideUp();
              $('.accordion.active').removeClass('active');
              $(this).addClass('active');
          }
          else
          {
              $(this).removeClass('active');
              $(this).next().stop().slideUp();
          }
      });
  });

